import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import AdSlot300x250 from "@/component/Ads/AdSlot300x250";
import AdSlot728x90 from "@/component/Ads/AdSlot728x90";

import RelatedNews from "@/component/RelatedNews";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import React, { useContext, useEffect, useMemo, useState } from "react";

import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";
import GTMScript from "@/component/Ads/GTMScript";
import WebpageSchema from "@/component/SeoTags/WebpageSchema";
import BreadcrumbSchema from "@/component/SeoTags/BreadcrumbSchema";
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const ItemsListSchema = dynamic(() => import("@/component/SeoTags/ItemsList"));
import HeadTag from "@/component/SeoTags/HeadTag";

import CommonFooter from "./CommanFooter";
import TopBanner from "./TopBanner";
import ScheduleComponent from "./ScheduleComponent";
import ShortsSection from "./Shorts";
import MPLiveTV from "./MPLiveTV";
// import UtsavFaqSchema from "@/component/SeoTags/UtsavFaqSchema";
// import EventUtsavSchema from "@/component/SeoTags/EventUtsavSchema";
const MGIDAAdsScript = dynamic(() => import("@/component/Ads/MGIDAdsScript"));

const LandingPage = ({
  categoryNewsList = null,
  faqData = null,
  isMobileDevice = false,
  photoData = null,
  storyData = null,
  videoData = null,
  electionLiveData = null,
}) => {
  const masterConfig = useContext(MasterConfigContext);
  const mp_baithaki = masterConfig["mp_baithaki"];

  const storiesData =
    storyData?.content ||
    categoryNewsList?.content?.filter((item) => item?.content_type == "story");
  // console.log("stories",categoryNewsList?.content,storiesData)
  const videosData =
    videoData?.content ||
    categoryNewsList?.content?.filter((item) => item?.content_type == "video");
  const photosData =
    photoData?.content ||
    categoryNewsList?.content?.filter(
      (item) => item?.content_type == "photo_gallery"
    );
  const router = useRouter();
  const currentPath = router?.asPath?.split("?")[0];
  const keyBindings = {
    Category:
      currentPath.split("/").length > 2
        ? [currentPath.split("/")[1], currentPath.split("/")[2]]
        : currentPath.split("/")[1],
    Keywords: storyData?.seo_detail?.meta_keyword?.split(",") || [],
  };
  const adKey = masterConfig["master_interstitial"];

  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    function handleScroll() {
      if (!scrolled) {
        setScrolled(true);
      }
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag &&
          googletag?.cmd.push(function () {
            if (!scrolled) {
              googletag.destroySlots();
              googletag
                .defineSlot(
                  "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                  [300, 250],
                  "div-gpt-ad-1659434453897-0"
                )
                ?.addService(googletag.pubads());
            }
            if (scrolled) {
              if (storiesData?.length > 0) {
                document.getElementById("div-gpt-ad-1659434604998-0") &&
                  googletag
                    .defineSlot(
                      "/1007232/News_tak_Mobile_ROS_MTF_1_300x250",
                      [300, 250],
                      "div-gpt-ad-1659434604998-0"
                    )
                    .addService(googletag.pubads());
              }

              document.getElementById("div-gpt-ad-1659435474737-0") &&
                googletag
                  .defineSlot(
                    "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                    [300, 250],
                    "div-gpt-ad-1659435474737-0"
                  )
                  .addService(googletag.pubads());
            }
            if (!scrolled) {
              googletag
                .defineSlot(
                  "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                  [320, 50],
                  "div-gpt-ad-1659435612077-0"
                )
                ?.addService(googletag.pubads());
            }
            // // googletag.pubads().enableSingleRequest();
            // googletag.pubads().disableInitialLoad();
            googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
            googletag.enableServices();
            requestBiddingFromPWT();
            // Object.keys(keyBindings).forEach((key) => {
            //   googletag.pubads().setTargeting(key, keyBindings[key]);
            // });
            !scrolled &&
              googletag.cmd.push(function () {
                var INTERSTITIALAd = googletag
                  .defineOutOfPageSlot(
                    "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                    googletag.enums.OutOfPageFormat.INTERSTITIAL
                  )
                  .addService(googletag.pubads());

                googletag.display(INTERSTITIALAd);
              });
          });
      } else {
        googletag.cmd.push(function () {
          if (!scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1659094777326-0"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1707804176041-1"
              )
              .addService(googletag.pubads());
          }
          if (scrolled) {
            if (storiesData?.length > 0) {
              googletag
                .defineSlot(
                  "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                  [728, 90],
                  "div-gpt-ad-1707804176041-2"
                )
                .addService(googletag.pubads());
            }
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1659425743360-0"
              )
              .addService(googletag.pubads());
          }
          // // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
        });
      }
      if (scrolled) {
        apstag?.fetchBids(
          {
            slots:
              window.screen.width < 900
                ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
                : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
            timeout: 2e3,
          },
          apstagBidCallback
        );
      }
    }, 10);

    try {
      // page query params
      const page = parseInt(router?.query?.page);
      if (page) {
        setCurrentPage(parseInt(page));
      }
    } catch (error) {
      console.error(error);
    }
  }, [scrolled]);

  useEffect(() => {
    const hash = window.location.hash;

    if (hash === "#videos" || hash === "#photos") {
      const element =
        document.getElementById("videos") || document.getElementById("photos");

      if (element) {
        // First scroll element into view
        element.scrollIntoView({ behavior: "smooth", block: "start" });

        setTimeout(() => {
          let offset = 110;
          if (hash === "#videos") {
            offset += 10;
          }
          window.scrollBy({ top: -offset, left: 0, behavior: "smooth" });
        }, 100);
      }
    }
  }, []);

  const landingContent = `भोपाल में MP Tak का सजेगा मंच. MP Tak बैठक में Madhya Pradesh के CM Dr. Mohan Yadav के साथ ही DY CM Rajendra Shukla और सभी बड़े नेता शिरकत करेंगे. MP Tak बैठक में हास्य और प्रेम रस के कवि प्रस्तुत करेंगे अपनी कविताएं. फिल्म से जुड़ी हस्तियां भी दिखाएंगी अपना जलवा। मध्य प्रदेश के तमाम मुद्दों पर चर्चा करेंगे वरिष्ठ पत्रकार । 8 जुलाई दोपहर 12 बजे से देखिए MP Tak बैठक.`;

  const firstActive = useMemo(() => {
    let first = false;
    let firstActiveItem = "";
    electionLiveData?.content &&
      Object?.keys(electionLiveData?.content).forEach((key) => {
        if (
          first === false &&
          electionLiveData?.content?.[key]?.status === "1"
        ) {
          firstActiveItem = key;
          first = true;
        }
      });
    return firstActiveItem;
  }, []);

  const meta_data = {
    title: `MPTak बैठक 2025: मध्यप्रदेश की ताज़ा राजनीतिक बैठकें, फैसले और अपडेट्स`,
    description: `MPTak बैठक 2025: जानें मध्यप्रदेश की राजनीति में चल रही अहम बैठकों, मंत्रिमंडल के फैसलों, विधायकों की बैठक, और सरकार से जुड़े बड़े निर्णयों की हर अपडेट। MP के राजनीतिक हलचल की सटीक जानकारी सिर्फ MPTak पर।`,
    keywords: `MPTak बैठक, MP बैठक 2025, MP बैठक आज, मध्यप्रदेश राजनीति, MP political news, CM meeting MP, विधायक बैठक मध्यप्रदेश, MP मंत्री बैठक, MP सरकार बैठक, MP cabinet decisions, Madhya Pradesh political update, एमपी टुडे न्यूज, MPTak political news`,
  };
  const eventSchema = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: "MPTak बैठक",
    description:
      "मध्यप्रदेश के राजनीतिक और सरकारी अपडेट पर आधारित MPTak द्वारा आयोजित बैठक। नवीनतम फैसलों, घोषणाओं और चर्चा के लिए जुड़ें।",
    startDate: "2025-07-08T10:30:00+05:30",
    endDate: "2025-07-08T17:10:00+05:30",
    eventStatus: "https://schema.org/EventScheduled",
    eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
    location: {
      "@type": "Place",
      name: "MPTak बैठक",
      address: {
        "@type": "PostalAddress",
        streetAddress: "होटल जहांनुमा पैलेस,भोपाल",
        addressLocality: "भोपाल",
        addressRegion: "Madhya Pradesh",
        postalCode: "462002",
        addressCountry: "IN",
      },
    },
    organizer: {
      "@type": "Organization",
      name: "MPTak",
      url: "https://www.newstak.in",
    },
    image: mp_baithaki?.desktopBannerUrl,
    url: "https://www.newstak.in/madhya-pradesh/mptak-baithak",
  };

  return (
    <div>
      <HeadTag
        title={meta_data?.title}
        description={meta_data?.description}
        keywords={meta_data?.keywords}
        canonicalUrl={
          router.asPath.includes("/photos")
            ? process.env.NEXT_PUBLIC_WEBSITE_URL + router.asPath
            : process.env.NEXT_PUBLIC_WEBSITE_URL +
            "/madhya-pradesh/mptak-baithak"
        }
        noAuthorTag={false}
        image={mp_baithaki?.desktopBannerUrl}
        lcpImage={`${storyData?.content?.[0]?.image_small}?size=360:203`}
      />
      <GTMScript />
      {/* <RichmediaScript isMobile={isMobileDevice} isHome={false}/> */}
      <WebpageSchema
        title={meta_data?.title}
        description={meta_data?.description}
        keywords={meta_data?.keywords}
        canonicalUrl={
          router.asPath.includes("/photos")
            ? process.env.NEXT_PUBLIC_WEBSITE_URL + router.asPath
            : process.env.NEXT_PUBLIC_WEBSITE_URL +
            "/madhya-pradesh/mptak-baithak"
        }
      />
      <BreadcrumbSchema breadcrumbList={storyData?.category_detail} />
      <ItemsListSchema data={storyData?.content} />
      <Breadcrumb breadcrumbList={storyData?.category_detail} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(eventSchema) }}
      />

      <MGIDAAdsScript delay={true} />
      <div className="mx-4">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />
        <AdSlot728x90
          divId="div-gpt-ad-1659094777326-0"
          minWidth="728px"
          minHeight="90px"
        />
      </div>

      <TopBanner masterConfigKey={mp_baithaki} />
      {mp_baithaki?.showLiveTV && (
        <div className="top-layer-election" style={{ position: "sticky" }}>
          <MPLiveTV
            electionLiveData={electionLiveData?.content}
            firstActive={firstActive}
          />
        </div>
      )}
      {!mp_baithaki?.showScheduleBelow && (
        <div className="mx-3 my-4">
          {" "}
          {mp_baithaki?.events?.length > 0 && (
            <ScheduleComponent events={mp_baithaki?.events} />
          )}
        </div>
      )}
      <div className="mx-3 my-4">
        {" "}
        {mp_baithaki?.youtubeShorts?.length > 0 && (
          <ShortsSection youtubeShorts={mp_baithaki?.youtubeShorts} />
        )}
      </div>
      <div className="mx-4 my-4">
        <div className="ml-2" id="videos">
          {(videosData?.length > 0 || videosData?.length > 0) && (
            <RelatedNews
              relatedNewsData={videosData}
              customTitle="वीडियो"
              isPhotoGallery={false}
            />
          )}
          <div id="photos">
            {(photosData?.length > 0 || photosData?.length > 0) && (
              <RelatedNews
                relatedNewsData={photosData}
                customTitle="फोटो गैलरी"
                isPhotoGallery={true}
              />
            )}
          </div>
        </div>
        <div className="mx-3 md:mx-4">
          {storiesData?.length > 0 && scrolled && (
            <AdSlot300x250
              divId="div-gpt-ad-1659434604998-0"
              minWidth="300px"
              minHeight="250px"
            />
          )}
          {storiesData?.length > 0 && scrolled && (
            <AdSlot728x90
              divId="div-gpt-ad-1707804176041-2"
              minWidth="728px"
              minHeight="90px"
            />
          )}
        </div>
      </div>
      {
        <div className=" ">
          <CommonFooter
            content={landingContent}
            categoryNewsList={storiesData}
            isMobileDevice={false}
            showAds={true}
            scrolled={scrolled}
            showContent={true}
          />
          {mp_baithaki?.showScheduleBelow && (
            <div className="mx-3 my-4">
              {" "}
              {mp_baithaki?.events?.length > 0 && (
                <ScheduleComponent events={mp_baithaki?.events} />
              )}
            </div>
          )}
          {scrolled && (
            <div className="mx-3 md:mx-4">
              <AdSlot300x250
                divId="div-gpt-ad-1659435474737-0"
                minWidth="300px"
                minHeight="250px"
              />
            </div>
          )}
          {scrolled && (
            <div className="mx-3 md:mx-4">
              <AdSlot728x90
                divId="div-gpt-ad-1659425743360-0"
                minWidth="728px"
                minHeight="90px"
              />
            </div>
          )}
        </div>
      }

      <div data-type="_mgwidget" data-widget-id="1584885"></div>
      <script
        async
        dangerouslySetInnerHTML={{
          __html: `window.addEventListener("load", function() {
          (function(w,q){w[q]=w[q]||[];w[q].push(["_mgc.load"])})(window,"_mgq");
        });`,
        }}
      ></script>
    </div>
  );
};

export default LandingPage;
